import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, FormControl } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { useStateValue } from '../context/state.jsx';
import { setNote } from '../offline-features/setNote.js';

const NoteModal = ({
	noteObj,
	setModalNoteObj
}) => {
	const [{ datasets }, dispatch] = useStateValue();
	const { datasetId } = useParams();
	const [localNoteText, setLocalNoteText] = useState(null);

	const noteTextareaChange = e => {
		setLocalNoteText(e.target.value);
	};

	const close = () => {
		setModalNoteObj(null);
	};

	const applyNote = () => {
		const noteCopy = Object.assign({}, noteObj);
		noteCopy.note = localNoteText;

		setNote(dispatch, datasetId, datasets[datasetId].AllowOffline, noteCopy);
		close();
	};

	if (!noteObj) {
		return null;
	}

	return (
		<Modal
			show={noteObj !== undefined}
			onHide={close}
			container={this}>
			<Modal.Header closeButton>
				<Modal.Title>{noteObj.type}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormControl
					componentClass="textarea"
					placeholder="Enter notes..."
					defaultValue={noteObj.note}
					onChange={noteTextareaChange} />
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={applyNote} className="floatLeft">Set Note</Button>
				<Button onClick={close}>Cancel</Button>
			</Modal.Footer>
		</Modal>
	);
};

NoteModal.propTypes = {
	noteObj: PropTypes.object,
	setModalNoteObj: PropTypes.func
};

export default NoteModal;
